import React from 'react';
import {DwellingData} from "./DwellingData";
import ViewDataContextProvider from "../../commons/context/view/ViewDataContext.js";
import FiltersDataContextProvider from "../../commons/context/FiltersDataContext";
import FiltersStateContextProvider from '../../commons/context/FiltersStateContext';

const DwellingView = (props) => {

        return (
            <FiltersDataContextProvider>
              <FiltersStateContextProvider context = {props.match.params.context}>
                <ViewDataContextProvider>
                  <DwellingData/>
                </ViewDataContextProvider>
              </FiltersStateContextProvider>   
            </FiltersDataContextProvider>

        )
}

export default DwellingView;


// WEBPACK FOOTER //
// ./src/components/dwelling/DwellingView.js